import { ulid } from 'ulid'

export default class AppLock {
  id: string = ulid()
}
